import appbase from 'hobbit-base/components/appbase/index.vue';

export default {
  name: 'app',
  data() {
    return {
      faqIMBtnEnable: false,
    };
  },
  created() {
    console.log(this.$dsBridge, 'dsBridge --- dsBridge');
  },
  methods: {},
  components: {
    appbase,
  },
};
